export const ConversationChannelType = {
  HoteldoorChat: 0,
  Email: 1,
  WhatsApp: 2,
} as const;

export type ConversationChannelType =
  (typeof ConversationChannelType)[keyof typeof ConversationChannelType];
